import { render, staticRenderFns } from "./BodyPainPanelOnlyDetail.vue?vue&type=template&id=bcf3cea2&scoped=true&"
import script from "./BodyPainPanelOnlyDetail.vue?vue&type=script&lang=js&"
export * from "./BodyPainPanelOnlyDetail.vue?vue&type=script&lang=js&"
import style0 from "./BodyPainPanelOnlyDetail.vue?vue&type=style&index=0&id=bcf3cea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf3cea2",
  null
  
)

export default component.exports